import React, { useContext } from 'react';
import { ExperienceContext } from 'status/context';

function useExperience() {
  const experience = useContext(ExperienceContext);
  return experience;
}

export default useExperience;
